// extracted by mini-css-extract-plugin
module.exports = {"container":"DotsButton_container__2xAzj","icon":"DotsButton_icon__1lmT9"};